import { HStack, Image, Stack } from '@mybridge/ui';
import { forwardRef } from 'react';
export const SupportLayout = forwardRef(({ children, ...props }, ref) => {
  return (
    <>
      <HStack
        flexDir={['column-reverse', 'column-reverse', 'row']}
        alignItems="stretch"
        py={12}
        w="100%"
        maxW="6xl"
        mx="auto"
        px={[4, 4, 0]}
      >
        <Stack justifyContent="flex-start" w={['full', 'full', '50%']}>
          {children}
        </Stack>
        <Stack
          justifyContent="center"
          w={['full', 'full', '50%']}
          alignItems="center"
        >
          <Image h={['40vh', '40vh', 'auto']} src="/support-ill.png" />
        </Stack>
      </HStack>
    </>
  );
});
